import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import Reveal, { SectionHead } from "@/components/Reveal";

const images = [
  { src: "https://customer-assets-agu9un31.emergentagent.net/job_player-cristian-diaz/artifacts/17ih4pei_IMG_9418.jpeg", alt: "Cristian Díaz, N°42 de Colo-Colo, conduciendo el balón en el Estadio Monumental", span: "sm:col-span-2 sm:row-span-2" },
  { src: "/fotos/foto01.jpg", alt: "Cristian Díaz conduciendo el balón con la camiseta de Colo-Colo", span: "" },
  { src: "https://customer-assets-agu9un31.emergentagent.net/job_player-cristian-diaz/artifacts/y0ve7kzg_IMG_9415.jpeg", alt: "Cristian Díaz ejecutando un pase largo ante la Garra Blanca", span: "" },
  { src: "/fotos/foto03.jpg", alt: "Cristian Díaz llegando al estadio con el buzo oficial de Colo-Colo", span: "" },
  { src: "/fotos/foto05.jpg", alt: "Cristian Díaz controlando el balón durante un partido de Colo-Colo", span: "" },
  { src: "https://customer-assets-agu9un31.emergentagent.net/job_player-cristian-diaz/artifacts/r0u3jubp_IMG_9420.jpeg", alt: "Cristian Díaz con la camiseta de la Roja Sub-17", span: "sm:col-span-2" },
  { src: "/fotos/foto06.jpg", alt: "Cristian Díaz celebrando con los brazos abiertos en la cancha", span: "" },
  { src: "/fotos/foto08.jpg", alt: "Cristian Díaz gambeteando con el balón en el mediocampo", span: "" },
  { src: "https://customer-assets-agu9un31.emergentagent.net/job_player-cristian-diaz/artifacts/18x6kqrb_IMG_9416.jpeg", alt: "Cristian Díaz ordenando a sus compañeros en el mediocampo", span: "" },
  { src: "/fotos/foto09.jpg", alt: "Cristian Díaz ingresando a la cancha junto a Arturo Vidal en Colo-Colo", span: "" },
  { src: "https://customer-assets-agu9un31.emergentagent.net/job_player-cristian-diaz/artifacts/8a3sskms_IMG_9419.jpeg", alt: "Cristian Díaz en carrera durante un partido con la Selección Chilena", span: "" },
  { src: "/fotos/foto11.jpg", alt: "Cristian Díaz perfilado para jugar el balón con Colo-Colo", span: "" },
  { src: "/fotos/foto12.jpg", alt: "Cristian Díaz, N°42, disputando el balón de espaldas al arco", span: "" },
];

export default function Galeria() {
  const [selected, setSelected] = useState(null);

  return (
    <section id="galeria" data-testid="galeria-section" className="relative py-28 px-6 border-t border-neutral-900">
      <div className="max-w-6xl mx-auto">
        <SectionHead eyebrow="04 — Galería" title="Momentos del Cacique" testId="galeria-title" />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 sm:auto-rows-[240px] gap-4" data-testid="gallery-grid">
          {images.map((img, i) => (
            <Reveal key={img.src} delay={i * 0.05} className={`group relative overflow-hidden border border-neutral-800 cursor-pointer ${img.span}`}>
              <button
                type="button"
                data-testid={`gallery-item-${i}`}
                onClick={() => setSelected(i)}
                className="block w-full sm:h-full"
                aria-label={`Ampliar: ${img.alt}`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-auto sm:h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <span className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-[#050505]/90 to-transparent p-4 font-tech text-[10px] uppercase tracking-[0.25em] text-neutral-300 opacity-0 group-hover:opacity-100 transition-opacity text-left">
                  {img.alt}
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {selected !== null && (
          <motion.div
            data-testid="gallery-lightbox"
            className="fixed inset-0 z-[60] bg-black/90 backdrop-blur-md flex items-center justify-center p-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelected(null)}
          >
            <motion.img
              src={images[selected].src}
              alt={images[selected].alt}
              className="max-h-[85vh] max-w-full object-contain border border-neutral-800"
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            />
            <button
              type="button"
              data-testid="gallery-lightbox-close"
              onClick={() => setSelected(null)}
              className="absolute top-6 right-6 text-neutral-400 hover:text-[#d4af37] transition-colors"
              aria-label="Cerrar"
            >
              <X size={32} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
